var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m584.6,286.92c-.24,2.93-1.73,5.74-4.33,7.56l-371.07,259.83,6.27-41.91h0c.4-2.67,1.86-5.18,4.25-6.85,0,0,371.14-259.87,371.14-259.87l-6.45,42.59",
    fill: "#26c44b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m446.54,462.53c-.24,2.93-1.73,5.74-4.33,7.56l-246.35,172.5,6.27-41.91h0c.4-2.67,1.86-5.18,4.25-6.85l246.41-172.54-6.45,42.59",
    fill: "#26c44b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m433.35,550.7c-.24,2.93-1.73,5.74-4.33,7.56l-246.35,172.5,6.27-41.91h0c.4-2.67,1.86-5.18,4.25-6.85l246.41-172.54-6.45,42.59",
    fill: "#26c44b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m611.09,110.5c-.24,2.93-1.73,5.74-4.33,7.56l-246.35,172.5,6.27-41.91h0c.4-2.67,1.86-5.18,4.25-6.85l246.41-172.54-6.45,42.59",
    fill: "#26c44b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m597.81,198.74c-.24,2.93-1.73,5.74-4.33,7.56l-246.35,172.5,6.27-41.91h0c.4-2.67,1.86-5.18,4.25-6.85l246.41-172.54-6.45,42.59",
    fill: "#26c44b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.be07228fb70465eb569ffa7ddf0f1f06.svg";
export { ForwardRef as ReactComponent };